<script>
  import Link from '../../../utils/link';
  import Card from '../../../components/containers/card.html';
  import Avatar from '../../../components/containers/avatar.html';

  export let person;

  function getPersonLink(person) {
    return `/people/view/${person.id}`;
  }
</script>

<Card hover>
  <Link href={getPersonLink(person)}>
    <div class="u--padall">
    <div class="grid-x grid-margin-x">
      <div class="cell small-12 medium-3">
        <Avatar avatar={person.avatar} />
      </div>
      <div class="cell small-12 medium-9">
        <h3>
          {person.firstName} {person.lastName}
        </h3>
        <a href="/">
          <h4>{person.household.primary.person.lastName} Household</h4>
        </a>
      </div>
    </div>
  </div>
  <hr />
  <div class="stat">
    <div class="grid-x">
      <div class="cell small-12 medium-12">
        <h4>Relationship</h4>
        <h5>{person.relationship}</h5>
      </div>
    </div>
  </div>
  
  </Link>
</Card>


